import { toast } from "react-toastify";
import { useLoaderData } from "react-router-dom";
import { createContext, useContext } from "react";
import { customFetch } from "../utils/custom-fetch.js";
import {
  BuildingsContainer,
  BuildingSearchContainer,
} from "../components/Building";
import { useNavigate } from "react-router-dom";

export const loader = async ({ request }) => {
  const params = Object.fromEntries(
    new URL(request.url).searchParams.entries()
  );

  try {
    /* שתי קריאות במקביל */
    const [{ data: buildingsData }, { data: companies }, { data : cities} ] = await Promise.all([
      customFetch.get("/buildings", { params }),
      customFetch.get("/buildings/maintenance-companies"),
      customFetch.get("/campaigns/cities-streets-buildings"),
    ]);

    const maintenanceCompanies = [
      { _id: "הכל", name: "הכל" },
      ...companies.map((c) => ({
        _id: c.value,
        name: c.lastName ? `${c.name} ${c.lastName}` : c.name,
      })),
    ];

    return { data: buildingsData, maintenanceCompanies, cities };
  } catch (err) {
    toast.error(err?.response?.data?.msg || "שגיאה בטעינת נתונים");
    throw err;
  }
};

/* ---------- context ---------- */
const AllBuildingsContext = createContext();
export const useAllBuildingsContext = () => useContext(AllBuildingsContext);

const AllBuildings = () => {
  const { data, maintenanceCompanies, cities } = useLoaderData();
  
  const navigate = useNavigate();
  return (
    <AllBuildingsContext.Provider value={{ data, maintenanceCompanies, cities }}>
      <button
        type="button"
        style={{ marginBottom: "1rem" }}
        className="btn btn-primary"
        onClick={() => navigate("/dashboard/add-building")}
      >
        צור בניין חדש
      </button>
      <BuildingSearchContainer />
      <BuildingsContainer />
    </AllBuildingsContext.Provider>
  );
};

export default AllBuildings;
